import { all, call } from "redux-saga/effects"

import creationFlow from "./creation/saga"
import deletionFlow from "./deletion/saga"

export function* participantsSaga() {
  yield all([call(creationFlow), call(deletionFlow)])
}
